import { Link as LinkIcon } from '@mui/icons-material'
import { GridActionsCellItem } from '@mui/x-data-grid'
import { useRef, useState } from 'react'
import type { SearchResultItem } from '@/features/search/types'
import { CopyLinkMenu } from '../../../actions/CopyMenu'

type Props = {
  item: SearchResultItem
}

export const CopyLinkAction = (props: Props) => {
  const ref = useRef(null)
  const [open, setOpen] = useState(false)
  const handleClose = () => setOpen(false)
  return (
    <>
      <GridActionsCellItem
        ref={ref}
        key="copy-link"
        icon={<LinkIcon />}
        label="Copy Media Link"
        title="Copy Media Link"
        onClick={() => {
          setOpen(true)
        }}
      />
      <CopyLinkMenu
        open={open}
        onClose={handleClose}
        anchorEl={ref.current}
        item={props.item}
      />
    </>
  )
}
